/**
 * SettingsInvitationStepReviewers form layout script class
 *
 * @package    Layouts
 * @author     Roman Kritskiy <rkritskiy@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React, { PureComponent, Fragment } from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import Divider from '@material-ui/core/Divider';
import { FormattedMessage } from 'react-intl';

import Button from 'Common/CustomButtons/Button';
import { ContactInfoForm } from 'Components/FormGroup';
import FormGroup from 'Components/FormGroup/FormGroup';
import { FormJournalAutocomplete } from 'Common/ReduxForm';

export default class SettingsInvitationStepReviewers extends PureComponent {
    /**
     * Props types
     *
     * @type {{journalFilter}}
     */
    static propTypes = {
        journalProps: PropTypes.object.isRequired,
        invites: PropTypes.array.isRequired,
        addInvite: PropTypes.func.isRequired,
        buildOnClear: PropTypes.func.isRequired,
    };

    /**
     * Render invites
     *
     * @returns {any[]}
     */
    renderInvites() {
        const { invites, buildOnClear } = this.props;

        return invites.map(number => (
            <Fragment key={number}>
                <Divider />
                <ContactInfoForm
                    required
                    namePrefix={`invitations[${number}].`}
                    onClear={invites.length > 1 ? buildOnClear(number) : false}
                />
            </Fragment>
        ));
    }

    /**
     * Render
     *
     * @returns {*}
     */
    render() {
        const { journalProps, addInvite } = this.props;

        return (
            <div>
                <FormGroup required title="form_groups.journal_selection">
                    <Field
                        withLabel
                        name="journal_id"
                        rowClassName="mm-form-field"
                        component={FormJournalAutocomplete}
                        label="journal_id"
                        placeholder="journal_id"
                        inputProps={ journalProps }
                    />
                </FormGroup>

                {this.renderInvites()}

                <Button color="primary" type="button" onClick={addInvite}>
                    <FormattedMessage id="button.more" />
                </Button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/layouts/Settings/components/SettingsInvitation/SettingsInvitationStepReviewers.jsx